import React from "react";

import copanLogo from "../../assets/logo_copan.webp";

import "./header.styles.css";

const Header = () => {
    return (
        <div className="header">
            <div className="header-logo-box">
                <img
                    className="header-logo-box-img"
                    src={copanLogo}
                    alt="logo copan"
                />
            </div>
        </div>
    );
};

export default Header;
